<template>
  <header class="phonebar">
    <app-icon-button
      v-if="back"
      icon="arrowLeft"
      label="Zurück"
      :size="44"
      :tooltip="false"
      @click="$emit('back')"
    />
    <img v-else src="/img/sima-star.png" alt="" width="24" height="24" class="phonebar__star" />
    <h1 class="phonebar__title">{{ title }}</h1>
    <app-icon-button
      v-if="action"
      :icon="action.icon"
      :label="action.label"
      :size="44"
      :tooltip="false"
      @click="runAction"
    />
    <!-- Mehr-Menü offen: an der Stelle der Seitenaktion der Knopf „Darstellung“ (Farbschema und Hauptfarbe) -->
    <app-theme-toggle v-if="themeToggle" :size="44" />
  </header>
</template>

<script>
// Handy-App-Leiste (Spezifikation 2.11, gen_r3.py:1586–1590): SIMA-Stern bzw. im Mehr-Untermenü „Zurück“, Titel 18/24,
// höchstens eine 44-px-Aktion aus $shell.phoneAction ({ icon, label, handler }; nicht bei offenem Mehr-Menü).
// Bei offenem Mehr-Menü (beide Ebenen) steht an dieser Stelle der Knopf „Darstellung“ (Farbschema und Hauptfarbe) (AppThemeToggle 44;
// Kundenwunsch 12.10.2026, Nachtrag 12.10.2026 Nr. 15). Er ist keine Zeile im Mehr-Menü; das Handy hat keine
// Systemleiste. Fläche --surface. Kein Avatar.
import AppThemeToggle from './AppThemeToggle.vue';

export default {
  name: 'AppPhoneBar',
  components: { AppThemeToggle },
  props: {
    title: { type: String, default: '' },
    back: { type: Boolean, default: false }
  },
  computed: {
    action() {
      const shell = this.$shell;
      const action = shell && !shell.moreOpen ? shell.phoneAction : null;
      return action && action.icon && action.label ? action : null;
    },
    themeToggle() {
      return !!(this.$shell && this.$shell.moreOpen);
    }
  },
  methods: {
    runAction() {
      if (this.action && typeof this.action.handler === 'function') {
        this.action.handler();
      }
    }
  }
};
</script>

<style scoped>
.phonebar {
  position: sticky;
  top: 0;
  z-index: 5;
  height: calc(56px + env(safe-area-inset-top, 0px));
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: env(safe-area-inset-top, 0px) 12px 0;
  background: var(--surface);
  border-bottom: 1px solid var(--line);
  font-family: var(--font);
}
/* SIMA-Stern wie oben in Seitenleiste und Rail (24), in einer 28er-Fläche wie bisher die Logo-Kachel */
.phonebar__star {
  width: 24px;
  height: 24px;
  flex: none;
  display: block;
  margin: 0 2px;
}
h1.phonebar__title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: var(--ink);
}
</style>
